<template>
  <div>
    <k-filters :filterOptions="filterOptions" @filter="handleFilterUpdate" />
  </div>
</template>

<script>
import KFilters from '@base-components/k-filters.vue';

export default {
  components: {
    KFilters,
  },

  data() {
    return {
      filterOptions: [
        {
          text: 'Hide public threads',
          key: 'hide_public',
        },
        {
          text: 'Hide private threads',
          key: 'hide_private',
        },
        {
          text: 'Hide threads not assigned to you',
          key: 'hide_not_assigned',
        },
        {
          text: 'Hide answered threads',
          key: 'hide_answered',
        },
        {
          text: 'Hide closed threads',
          key: 'hide_closed_threads',
        },
        {
          text: 'Hide discussions',
          key: 'hide_discussions',
        },
        {
          text: 'Hide bug reports',
          key: 'hide_bug_reports',
        },
        {
          text: 'Hide threads awaiting answer',
          key: 'hide_awaiting_answer',
        },
      ],
    };
  },

  methods: {
    handleFilterUpdate(activeFilters) {
      const apiQueryString = activeFilters.map(filter => `${filter.key}=true`).join('&');
      this.$emit('filters-updated', apiQueryString);
    },
  },
};
</script>
